import { Dialog, IconButton } from "@mui/material";
import styled from "styled-components/macro";

export const CfcReportDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: calc(100% - 64px);
    max-width: 925px;
    height: calc(100% - 126px);
    max-height: 957px;
    border-radius: 6px;
    overflow: hidden;

    @media (max-width: 800px) {
      width: calc(100% - 24px);
      height: calc(100% - 24px);
      max-height: calc(100% - 24px);
      margin: 12px;
    }
  }
`;

export const CfcReportHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 72px;
  padding: 24px 32px;
  background-color: ${({ theme }) => theme.neutral50};
  border-bottom: 1px solid ${({ theme }) => theme.neutral100};
`;

export const CfcReportTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.redMedium};
  font-family: caps;
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
`;

export const CfcReportCloseButton = styled(IconButton)`
  && {
    color: ${({ theme }) => theme.redMedium};
  }
`;

export const CfcReportBackBar = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 54px;
  padding: 16px 16px 8px;
  background-color: ${({ theme }) => theme.white};
`;

export const CfcReportBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 10px 0 0;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.redMedium};
  cursor: pointer;
  font-family: light;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;

  svg {
    width: 20px;
    font-size: 14px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const CfcReportFrameArea = styled.section`
  position: relative;
  height: calc(100% - 126px);
  min-height: 320px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.neutral50};
`;

export const CfcReportPdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  background-color: ${({ theme }) => theme.white};
`;

export const CfcReportStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  color: ${({ theme }) => theme.greyDark};
  font-family: light;
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  svg {
    font-size: 24px;
  }
`;

export const CfcReportError = styled(CfcReportStatus)`
  flex-direction: column;
  gap: 16px;
  color: ${({ theme }) => theme.redDark};
`;

export const CfcReportRetryButton = styled.button`
  min-height: 32px;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.redDark};
  border-radius: 99px;
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.redDark};
  cursor: pointer;
  font-family: bold;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;

  &:hover {
    background: ${({ theme }) => theme.redDark};
    color: ${({ theme }) => theme.white};
  }
`;
